exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delete-warning[data-v-9ebe18d4] {\n  font-size: 1rem;\n  color: red;\n}\n.card[data-v-9ebe18d4] {\n  background: #ebeff3;\n  border-radius: 10px;\n}\n.card .bar[data-v-9ebe18d4] {\n    width: 100%;\n    height: 10px;\n    border-radius: 10px 10px 0 0;\n}\n.card .card-header[data-v-9ebe18d4] {\n    border-radius: 10px 10px 0 0;\n    background-color: #e7e7e7;\n    padding: 1rem;\n}\n.top-layer[data-v-9ebe18d4] {\n  justify-content: space-between;\n  padding: 0 1.25em;\n}\n.modal-button[data-v-9ebe18d4] {\n  border-radius: 0px;\n  margin-left: 5px;\n  margin-right: 5px;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  float: right !important;\n}\n.required[data-v-9ebe18d4] {\n  color: red;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9ebe18d4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/authConfig.vue
// module id = 1362
// module chunks = 2